export const ErrorTypes = {
  ABORT: 'ABORT',
  TIMEOUT: 'TIMEOUT',
};

export const ErrorMessages = {
  INVALID_JSON_STRING: 'Received an invalid JSON string',
  INVALID_ORGANIZATION: 'You did not set a valid organization. Call `flow.client.setOrganization()` with your organization.',
  NETWORK_ERROR: 'A network error has occurred while processing your request. Please try again.',
  REQUEST_TIMEDOUT: 'A network error has occurred, request timed out. Please try again.',
};
